<template>
  <div class="my-4">
    <v-row dense>
      <v-col cols="12" md="6" lg="3">
        <div class="text-caption text--secondary">{{ $t('records_returned') }}</div>
        <div class="text-body-2"><if-set :value="item.records_returned" dash/></div>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <div class="text-caption text--secondary">{{ $t('response_time_ms') }}</div>
        <div class="text-body-2"><if-set :value="item.response_time_ms" dash/></div>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <div class="text-caption text--secondary">{{ $t('ip_address') }}</div>
        <div class="text-body-2"><if-set :value="item.ip_address" dash/></div>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <div class="text-caption text--secondary">{{ $t('user_agent') }}</div>
        <div class="text-body-2 break-anywhere"><if-set :value="item.user_agent" dash/></div>
      </v-col>
    </v-row>

    <div class="text-caption text--secondary mt-3">{{ $t('query_parameters') }}</div>
    <v-simple-table v-if="queryParameterRows.length > 0" dense class="query-parameter-table">
      <thead>
        <tr>
          <th>{{ $t('parameter') }}</th>
          <th>{{ $t('value') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in queryParameterRows" :key="row.parameter">
          <td class="font-weight-medium">{{ row.parameter }}</td>
          <td class="break-anywhere">{{ row.value }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <div v-else-if="queryParametersText !== null" class="text-body-2 break-anywhere">
      {{ queryParametersText }}
    </div>
    <div v-else class="text-body-2 text--secondary">{{ $t('none') }}</div>
  </div>
</template>

<script>

import IfSet from '@/components/shared/IfSet'

/**
 * The per request detail shown when a row of the API request browser is
 * expanded: what the caller asked for, how much came back, how long it took and
 * where it came from.
 *
 * Renders entirely from the record the index request already returned, so
 * opening a row costs no extra API call.
 */
export default {
  name: 'ApiAccessLogDetails',
  components: {
    IfSet
  },
  props: {
    /**
     * The ApiAccessLogRecord to describe.
     */
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    queryParameterRows () {
      return this.item.queryParameterRows || []
    },
    /**
     * Normalized to null when the record has nothing to show this way, so the
     * template can distinguish it from an empty string it should still print.
     */
    queryParametersText () {
      const text = this.item.queryParametersText
      return text === undefined ? null : text
    }
  }
}
</script>

<style scoped lang="scss">
// User agents and parameter values can be long and have nothing to wrap on, so
// let them break anywhere rather than stretching the layout.
.break-anywhere {
  overflow-wrap: anywhere;
}

.query-parameter-table {
  max-width: 900px;
}
</style>
